/* eslint-disable */
export default {
  download: 'Lataa',
  play: 'Toista',
  pause: 'Tauko',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
